// @flow
import React from 'react';
import styled, { css } from 'styled-components';
import type { HOC as ElementType } from 'recompose';
import { Space } from './../Space';
import { Flex } from '../../components/Flex';

export const Container = styled(Space)`
  background: ${({ bg = 'transparent' }) => `var(--color-${bg})`};
  height: ${({ height = 'auto' }) => height};
  width: ${({ width = 'auto' }) => width};
  ${({ position }) =>
    position
      ? css`
          position: ${position};
        `
      : ''};
`;

export const VCenter = styled(Flex)`
  align-items: center;
`;
export const HContainer = ({
  children,
  ...props
}: {
  children: ElementType,
  ...Object,
}) => (
  <Container align="center" justify="space-between" flexAuto {...props}>
    {children}
  </Container>
);

export const HContainerCentered = styled(HContainer)`
  align-items: center;
  justify-content: center;
`;

export const VContainer = ({
  children,
  ...props
}: {
  children: ElementType,
  ...Object,
}) => (
  <Container flexColumn {...props}>
    {children}
  </Container>
);

export const HContainerHOC = (Comp: ElementType) => (props: any) => (
  <HContainer>
    <Comp {...props} />
  </HContainer>
);
